// Curated tuning estimates (Stage 1) for popular models. Values are typical safe estimates.
// Format: Brand -> Model -> Engine -> { hp, nm, ghp (gain hp), gnm (gain nm), ecu }
export const TUNING_DB = {
  BMW: {
    "Série 1 (F40)": {
      "118d 150 ch": { hp: 150, nm: 350, ghp: 35, gnm: 80, ecu: "Bosch EDC17C76" },
      "120d 190 ch": { hp: 190, nm: 400, ghp: 35, gnm: 80, ecu: "Bosch EDC17C76" },
      "M135i 306 ch": { hp: 306, nm: 450, ghp: 45, gnm: 80, ecu: "Bosch MG1CS003" },
    },
    "Série 3 (G20)": {
      "320d 190 ch": { hp: 190, nm: 400, ghp: 35, gnm: 80, ecu: "Bosch EDC17C76" },
      "330i 258 ch": { hp: 258, nm: 400, ghp: 45, gnm: 90, ecu: "Bosch MG1CS201" },
      "M340i 374 ch": { hp: 374, nm: 500, ghp: 55, gnm: 100, ecu: "Bosch MG1CS003" },
    },
    "Série 5 (G30)": {
      "520d 190 ch": { hp: 190, nm: 400, ghp: 40, gnm: 90, ecu: "Bosch EDC17C76" },
      "530d 265 ch": { hp: 265, nm: 620, ghp: 45, gnm: 110, ecu: "Bosch EDC17CP45" },
      "540i 340 ch": { hp: 340, nm: 450, ghp: 55, gnm: 100, ecu: "Bosch MG1CS003" },
    },
    "X3 (G01)": {
      "xDrive20d 190 ch": { hp: 190, nm: 400, ghp: 40, gnm: 90, ecu: "Bosch EDC17C76" },
      "M40i 360 ch": { hp: 360, nm: 500, ghp: 50, gnm: 90, ecu: "Bosch MG1CS003" },
    },
    "X5 (G05)": {
      "xDrive30d 265 ch": { hp: 265, nm: 620, ghp: 45, gnm: 110, ecu: "Bosch EDC17CP45" },
      "M50d 400 ch": { hp: 400, nm: 760, ghp: 35, gnm: 90, ecu: "Bosch EDC17CP45" },
      "xDrive40i 340 ch": { hp: 340, nm: 450, ghp: 60, gnm: 110, ecu: "Bosch MG1CS003" },
    },
  },
  Audi: {
    "A1 (GB)": {
      "30 TFSI 110 ch": { hp: 110, nm: 200, ghp: 25, gnm: 50, ecu: "Bosch MED17.1" },
      "40 TFSI 200 ch": { hp: 200, nm: 320, ghp: 40, gnm: 80, ecu: "Continental Simos 19" },
    },
    "A3 (8Y)": {
      "30 TDI 116 ch": { hp: 116, nm: 300, ghp: 30, gnm: 70, ecu: "Bosch MD1CS004" },
      "35 TDI 150 ch": { hp: 150, nm: 360, ghp: 40, gnm: 90, ecu: "Bosch MD1CS004" },
      "S3 310 ch": { hp: 310, nm: 400, ghp: 50, gnm: 90, ecu: "Continental Simos 19" },
    },
    "A4 (B9)": {
      "2.0 TDI 190 ch": { hp: 190, nm: 400, ghp: 40, gnm: 90, ecu: "Bosch EDC17C74" },
      "2.0 TFSI 252 ch": { hp: 252, nm: 370, ghp: 45, gnm: 90, ecu: "Continental Simos 18" },
      "3.0 TDI 286 ch": { hp: 286, nm: 620, ghp: 50, gnm: 110, ecu: "Bosch MD1CP004" },
    },
    "A6 (C8)": {
      "40 TDI 204 ch": { hp: 204, nm: 400, ghp: 45, gnm: 100, ecu: "Bosch MD1CP004" },
      "50 TDI 286 ch": { hp: 286, nm: 620, ghp: 50, gnm: 110, ecu: "Bosch MD1CP004" },
    },
    "Q5 (FY)": {
      "40 TDI 204 ch": { hp: 204, nm: 400, ghp: 45, gnm: 100, ecu: "Bosch MD1CP004" },
      "45 TFSI 265 ch": { hp: 265, nm: 370, ghp: 45, gnm: 90, ecu: "Continental Simos 18" },
    },
  },
  Volkswagen: {
    "Polo (Mk6)": {
      "1.0 TSI 95 ch": { hp: 95, nm: 175, ghp: 25, gnm: 45, ecu: "Bosch MED17.1" },
      "GTI 207 ch": { hp: 207, nm: 320, ghp: 40, gnm: 80, ecu: "Continental Simos 19" },
    },
    "Golf (Mk8)": {
      "2.0 TDI 150 ch": { hp: 150, nm: 360, ghp: 40, gnm: 90, ecu: "Bosch MD1CS004" },
      "GTI 245 ch": { hp: 245, nm: 370, ghp: 45, gnm: 90, ecu: "Continental Simos 19" },
      "R 320 ch": { hp: 320, nm: 420, ghp: 50, gnm: 90, ecu: "Continental Simos 19" },
    },
    "Passat (B8)": {
      "2.0 TDI 150 ch": { hp: 150, nm: 340, ghp: 40, gnm: 90, ecu: "Bosch EDC17C64" },
      "2.0 TDI 190 ch": { hp: 190, nm: 400, ghp: 40, gnm: 95, ecu: "Bosch EDC17C64" },
    },
    "Tiguan (Mk2)": {
      "2.0 TDI 150 ch": { hp: 150, nm: 340, ghp: 40, gnm: 90, ecu: "Bosch MD1CS004" },
      "2.0 TSI 190 ch": { hp: 190, nm: 320, ghp: 40, gnm: 80, ecu: "Continental Simos 18" },
    },
    "Transporter T6": {
      "2.0 TDI 150 ch": { hp: 150, nm: 340, ghp: 35, gnm: 80, ecu: "Bosch EDC17C64" },
      "2.0 BiTDI 199 ch": { hp: 199, nm: 450, ghp: 40, gnm: 90, ecu: "Bosch EDC17C64" },
    },
  },
  "Mercedes-Benz": {
    "Classe A (W177)": {
      "A180d 116 ch": { hp: 116, nm: 260, ghp: 30, gnm: 60, ecu: "Bosch MD1" },
      "A200d 150 ch": { hp: 150, nm: 320, ghp: 35, gnm: 80, ecu: "Bosch MD1" },
      "A35 AMG 306 ch": { hp: 306, nm: 400, ghp: 45, gnm: 80, ecu: "Bosch MED17" },
    },
    "Classe C (W205)": {
      "C200d 160 ch": { hp: 160, nm: 360, ghp: 35, gnm: 80, ecu: "Bosch EDC17C66" },
      "C220d 194 ch": { hp: 194, nm: 400, ghp: 40, gnm: 90, ecu: "Bosch EDC17C66" },
      "C300 258 ch": { hp: 258, nm: 370, ghp: 45, gnm: 90, ecu: "Bosch MED17.7" },
    },
    "Classe E (W213)": {
      "E220d 194 ch": { hp: 194, nm: 400, ghp: 45, gnm: 100, ecu: "Bosch EDC17C66" },
      "E300d 245 ch": { hp: 245, nm: 500, ghp: 45, gnm: 100, ecu: "Bosch MD1" },
    },
    "GLC (X253)": {
      "220d 194 ch": { hp: 194, nm: 400, ghp: 45, gnm: 100, ecu: "Bosch EDC17C66" },
      "300 258 ch": { hp: 258, nm: 370, ghp: 45, gnm: 90, ecu: "Bosch MED17.7" },
    },
  },
  Renault: {
    "Clio V": {
      "1.5 dCi 115 ch": { hp: 115, nm: 260, ghp: 25, gnm: 55, ecu: "Continental SID310" },
      "1.3 TCe 130 ch": { hp: 130, nm: 240, ghp: 30, gnm: 60, ecu: "Continental EMS3160" },
    },
    "Mégane IV": {
      "1.5 dCi 115 ch": { hp: 115, nm: 260, ghp: 25, gnm: 50, ecu: "Continental SID310" },
      "1.6 dCi 130 ch": { hp: 130, nm: 320, ghp: 30, gnm: 60, ecu: "Continental SID310" },
      "RS 280 ch": { hp: 280, nm: 390, ghp: 35, gnm: 70, ecu: "Continental EMS3160" },
    },
    "Trafic III": {
      "2.0 dCi 145 ch": { hp: 145, nm: 350, ghp: 30, gnm: 70, ecu: "Continental SID310" },
    },
  },
  Ford: {
    "Fiesta (Mk8)": {
      "1.0 EcoBoost 100 ch": { hp: 100, nm: 170, ghp: 25, gnm: 50, ecu: "Bosch MG1" },
      "ST 200 ch": { hp: 200, nm: 290, ghp: 35, gnm: 70, ecu: "Bosch MG1" },
    },
    "Focus (Mk4)": {
      "1.5 EcoBlue 120 ch": { hp: 120, nm: 300, ghp: 30, gnm: 70, ecu: "Bosch MD1CS006" },
      "1.5 EcoBoost 182 ch": { hp: 182, nm: 240, ghp: 30, gnm: 60, ecu: "Bosch MG1" },
      "ST 280 ch": { hp: 280, nm: 420, ghp: 35, gnm: 70, ecu: "Bosch MG1" },
    },
    "Ranger": {
      "2.0 EcoBlue 170 ch": { hp: 170, nm: 420, ghp: 35, gnm: 80, ecu: "Bosch MD1CS006" },
      "2.0 EcoBlue 213 ch": { hp: 213, nm: 500, ghp: 35, gnm: 80, ecu: "Bosch MD1CS006" },
    },
  },
  Peugeot: {
    "208 II": {
      "1.5 BlueHDi 100 ch": { hp: 100, nm: 250, ghp: 25, gnm: 55, ecu: "Delphi DCM6.2" },
      "1.2 PureTech 130 ch": { hp: 130, nm: 230, ghp: 25, gnm: 55, ecu: "Bosch MG1" },
    },
    "308 II": {
      "1.5 BlueHDi 130 ch": { hp: 130, nm: 300, ghp: 30, gnm: 65, ecu: "Delphi DCM6.2" },
      "2.0 BlueHDi 180 ch": { hp: 180, nm: 400, ghp: 30, gnm: 70, ecu: "Bosch MD1CS003" },
    },
    "3008 II": {
      "1.5 BlueHDi 130 ch": { hp: 130, nm: 300, ghp: 30, gnm: 65, ecu: "Delphi DCM6.2" },
      "2.0 BlueHDi 180 ch": { hp: 180, nm: 400, ghp: 30, gnm: 70, ecu: "Bosch MD1CS003" },
    },
  },
  Citroen: {
    "C3 III": {
      "1.5 BlueHDi 100 ch": { hp: 100, nm: 250, ghp: 25, gnm: 55, ecu: "Delphi DCM6.2" },
      "1.2 PureTech 110 ch": { hp: 110, nm: 205, ghp: 25, gnm: 50, ecu: "Bosch MG1" },
    },
    "C4 III": {
      "1.5 BlueHDi 130 ch": { hp: 130, nm: 300, ghp: 30, gnm: 65, ecu: "Delphi DCM6.2" },
    },
    "Berlingo III": {
      "1.5 BlueHDi 130 ch": { hp: 130, nm: 300, ghp: 30, gnm: 65, ecu: "Delphi DCM6.2" },
    },
  },
  Seat: {
    "Ibiza (KJ)": {
      "1.0 TSI 95 ch": { hp: 95, nm: 175, ghp: 25, gnm: 45, ecu: "Bosch MED17.1" },
      "1.6 TDI 95 ch": { hp: 95, nm: 250, ghp: 30, gnm: 65, ecu: "Bosch MD1CS004" },
    },
    "Leon (KL)": {
      "2.0 TDI 150 ch": { hp: 150, nm: 360, ghp: 40, gnm: 90, ecu: "Bosch MD1CS004" },
      "Cupra 300 ch": { hp: 300, nm: 400, ghp: 50, gnm: 90, ecu: "Continental Simos 19" },
    },
  },
  Skoda: {
    "Octavia IV": {
      "2.0 TDI 150 ch": { hp: 150, nm: 360, ghp: 40, gnm: 90, ecu: "Bosch MD1CS004" },
      "RS 245 ch": { hp: 245, nm: 370, ghp: 45, gnm: 90, ecu: "Continental Simos 19" },
    },
    "Kodiaq": {
      "2.0 TDI 150 ch": { hp: 150, nm: 340, ghp: 40, gnm: 90, ecu: "Bosch MD1CS004" },
      "2.0 TSI 190 ch": { hp: 190, nm: 320, ghp: 40, gnm: 80, ecu: "Continental Simos 18" },
    },
  },
  Volvo: {
    "XC60 (II)": {
      "B4 D 197 ch": { hp: 197, nm: 420, ghp: 40, gnm: 90, ecu: "Denso" },
      "T6 310 ch": { hp: 310, nm: 400, ghp: 45, gnm: 80, ecu: "Denso" },
    },
    "V60 (II)": {
      "D4 190 ch": { hp: 190, nm: 400, ghp: 40, gnm: 90, ecu: "Denso" },
    },
  },
  Toyota: {
    "Yaris (XP21)": {
      "1.5 Hybride 116 ch": { hp: 116, nm: 141, ghp: 15, gnm: 25, ecu: "Denso" },
    },
    "Hilux": {
      "2.4 D-4D 150 ch": { hp: 150, nm: 400, ghp: 30, gnm: 80, ecu: "Denso" },
      "2.8 D-4D 204 ch": { hp: 204, nm: 500, ghp: 35, gnm: 90, ecu: "Denso" },
    },
  },
  Nissan: {
    "Qashqai (J11)": {
      "1.5 dCi 115 ch": { hp: 115, nm: 260, ghp: 25, gnm: 55, ecu: "Continental SID310" },
      "1.3 DIG-T 160 ch": { hp: 160, nm: 270, ghp: 30, gnm: 60, ecu: "Continental EMS3160" },
    },
    "Navara (D23)": {
      "2.3 dCi 190 ch": { hp: 190, nm: 450, ghp: 35, gnm: 85, ecu: "Continental SID310" },
    },
  },
  Fiat: {
    "500 / 500X": {
      "1.3 MultiJet 95 ch": { hp: 95, nm: 200, ghp: 25, gnm: 55, ecu: "Bosch EDC17" },
      "1.6 MultiJet 120 ch": { hp: 120, nm: 320, ghp: 30, gnm: 70, ecu: "Bosch EDC17" },
    },
    "Ducato": {
      "2.3 MultiJet 140 ch": { hp: 140, nm: 350, ghp: 35, gnm: 90, ecu: "Bosch EDC17" },
      "2.3 MultiJet 180 ch": { hp: 180, nm: 450, ghp: 35, gnm: 90, ecu: "Bosch EDC17" },
    },
  },
  "Alfa Romeo": {
    "Giulia": {
      "2.2 JTDm 190 ch": { hp: 190, nm: 450, ghp: 35, gnm: 90, ecu: "Bosch MD1" },
      "2.0 GME 280 ch": { hp: 280, nm: 400, ghp: 40, gnm: 80, ecu: "Bosch MED17" },
    },
    "Stelvio": {
      "2.2 JTDm 210 ch": { hp: 210, nm: 470, ghp: 35, gnm: 90, ecu: "Bosch MD1" },
    },
  },
  Porsche: {
    "Macan": {
      "2.0 TFSI 245 ch": { hp: 245, nm: 370, ghp: 45, gnm: 90, ecu: "Continental Simos 18" },
      "S 354 ch": { hp: 354, nm: 480, ghp: 50, gnm: 90, ecu: "Bosch MG1" },
    },
    "911 (992)": {
      "Carrera 385 ch": { hp: 385, nm: 450, ghp: 55, gnm: 90, ecu: "Bosch MG1" },
      "Carrera S 450 ch": { hp: 450, nm: 530, ghp: 60, gnm: 100, ecu: "Bosch MG1" },
    },
  },
  Mini: {
    "Cooper (F56)": {
      "Cooper D 116 ch": { hp: 116, nm: 270, ghp: 30, gnm: 65, ecu: "Bosch EDC17" },
      "Cooper S 192 ch": { hp: 192, nm: 280, ghp: 40, gnm: 80, ecu: "Bosch MG1" },
      "JCW 231 ch": { hp: 231, nm: 320, ghp: 45, gnm: 80, ecu: "Bosch MG1" },
    },
  },
  Hyundai: {
    "i30 (PD)": {
      "1.6 CRDi 136 ch": { hp: 136, nm: 300, ghp: 30, gnm: 70, ecu: "Bosch EDC17" },
      "N 280 ch": { hp: 280, nm: 392, ghp: 35, gnm: 70, ecu: "Continental" },
    },
    "Tucson (NX4)": {
      "1.6 CRDi 136 ch": { hp: 136, nm: 320, ghp: 30, gnm: 70, ecu: "Bosch EDC17" },
    },
  },
  Kia: {
    "Ceed (CD)": {
      "1.6 CRDi 136 ch": { hp: 136, nm: 320, ghp: 30, gnm: 70, ecu: "Bosch EDC17" },
    },
    "Sportage (NQ5)": {
      "1.6 CRDi 136 ch": { hp: 136, nm: 320, ghp: 30, gnm: 70, ecu: "Bosch EDC17" },
    },
  },
  Dacia: {
    "Duster II": {
      "1.5 dCi 115 ch": { hp: 115, nm: 260, ghp: 25, gnm: 55, ecu: "Continental SID310" },
    },
    "Sandero III": {
      "1.0 TCe 90 ch": { hp: 90, nm: 160, ghp: 20, gnm: 40, ecu: "Continental EMS3160" },
    },
  },
  "Land Rover": {
    "Defender (L663)": {
      "D200 200 ch": { hp: 200, nm: 430, ghp: 35, gnm: 85, ecu: "Bosch MD1" },
      "D300 300 ch": { hp: 300, nm: 650, ghp: 45, gnm: 100, ecu: "Bosch MD1" },
    },
    "Discovery Sport": {
      "D180 180 ch": { hp: 180, nm: 430, ghp: 35, gnm: 85, ecu: "Bosch MD1" },
    },
  },
};
